import { render, staticRenderFns } from "./mod2.vue?vue&type=template&id=5d91170d&scoped=true&"
import script from "./mod2.vue?vue&type=script&lang=js&"
export * from "./mod2.vue?vue&type=script&lang=js&"
import style0 from "./mod2.vue?vue&type=style&index=0&id=5d91170d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d91170d",
  null
  
)

export default component.exports